export default __webpack_public_path__ + "static/media/connectivity.617a0702.jpg";